<div *ngIf="isAdmin && items.length" @slideIn class="tea" role="alert" aria-live="polite">
  <div class="tea__head">
    <span class="tea__bell"><mat-icon>notifications_active</mat-icon></span>
    <strong>Trial ended for {{ items.length }} {{ items.length === 1 ? 'company' : 'companies' }}.</strong>
    <span class="tea__sub">Turn Terms &amp; Conditions / KYC back on, or extend the trial.</span>
  </div>
  <div class="tea__list">
    <div *ngFor="let it of items" class="tea__item">
      <span class="tea__name">{{ it.companyName }}</span>
      <span class="tea__meta">{{ it.partyType }} · ended {{ endedOn(it) | date: 'dd MMM yyyy' }} · skipping {{ it.skipTerms && it.skipKyc ? 'T&C and KYC' : it.skipTerms ? 'T&C' : 'KYC' }}</span>
      <button mat-flat-button color="primary" class="tea__btn" (click)="review(it)">Review</button>
    </div>
  </div>
</div>
